<template>
  <div>
    <v-container fluid class="my-0 py-0">
      <v-card class="mt-3" :elevation="8">
        <Avanzamento
          :rotta_back="rotta_back"
        />
      </v-card>
    </v-container>
  </div>
</template>
<script>
import Avanzamento from "@/views/PRODUCTION/Avanzamento/Avanzamento.vue";

export default {
  name: "EMAvanzamentoAdapter",
  props: [],
  components: {
    Avanzamento,
  },
  data() {
    return {
      // Variabili d'appoggio
        rotta_back: '/home/electrical',
      // Modal

      // Array
    };
  },
  watch: {},
  methods: {},
  mounted() {},
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
